import React from "react";
import { Link } from "react-router-dom";
import "../Css/referrals.css";
import BannerImg from "../Img/Final-images/Referrals-banner-images.png";
function Referrals() {
  return (
    <>
      <section className="referral-s text-center mobile-view">
        <div>
          <img src={BannerImg} className="w-100" />
        </div>
        <div className="container mobile-view-none">
          <div className="breadcrumb-container" aria-label="Breadcrumb">
            <ul className="breadcrumbs">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li aria-current="page">Referrals</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="child-rights py-5">
        <div className="container">
          {/* Heading */}
          <div className="text-center mb-5">
            <h2 className="sub-heading text-center mb-1 fw-bold mb-4">
              REFERRALS
            </h2>
            <p className="">
              Affinity Childrens Services Limited welcomes referrals from local
              authorities and placing agencies. All referrals are assessed by
              the Registered Manager and Responsible Individual to ensure:
            </p>
          </div>
          {/* Cards */}
          <div className="row g-4 justify-content-center">
            {/* Card 1 */}
            <div className="col-lg-3 col-md-6">
              <div className="rights-card h-100 text-center p-4">
                {/* Card 1<div className="icon-circle mb-3">🏠</div> */}
                <h5 className="fw-semibold">
                  The home can meet the child’s needs
                </h5>
              </div>
            </div>
            {/* Card 2 */}
            <div className="col-lg-3 col-md-6">
              <div className="rights-card h-100 text-center p-4">
                {/* Card 2 <div className="icon-circle mb-3">⚠️</div>*/}
                <h5 className="fw-semibold">
                  Stability for existing children is maintained
                </h5>
              </div>
            </div>
            {/* Card 3 */}
            <div className="col-lg-3 col-md-6">
              <div className="rights-card h-100 text-center p-4">
                {/* Card 3<div className="icon-circle mb-3">🛡️</div> */}
                <h5 className="fw-semibold">
                  Appropriate staffing arrangements are in place
                </h5>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-lg-3 col-md-6">
              <div className="rights-card h-100 text-center p-4">
                {/* Card 4<div className="icon-circle mb-3">🛡️</div> */}
                <h5 className="fw-semibold">
                  Planned transitions are prioritised wherever possible
                </h5>
              </div>
            </div>
          </div>
          {/* Bottom Info Box */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <div className="info-box p-4 text-center">
                <p className="mb-0 text-center">
                  <strong>Email</strong>:
                  <a
                    href="mailto:info@affinitychildrens.co.uk"
                    class="email-link"
                  >
                    referrals@affinitychildrens.co.uk
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Referrals;
